import React, { useEffect } from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

const Select = (props) => {
  const { input, id, name, options, meta, } = props;
  const { placeholder = '', } = props;
  const { allowEmptyOption = true, } = props;
  const value = options.find((option) => option.value === input.value);
  const isInvalid = meta.touched && meta.error === 'Required';
  const isCorrect = Boolean(value)
  const isSearchable = props.isSearchable ? props.isSearchable : false;
  useEffect(() => {
    if (allowEmptyOption && options.length && options[0].value !== null) {
      options.unshift({ value: null, label: '', });
    }
  }, [value]);

  return (
    <ReactSelect
      {...input}
      id={id}
      name={name}
      options={options}
      value={value}
      placeholder={placeholder}
      isSearchable={isSearchable}
      styles={customStyles({ isInvalid, isCorrect, })}
      onChange={(option) => input.onChange(option.value)}
      onBlur={(event) => event.preventDefault()}
      menuPosition={'absolute'}
      menuPortalTarget={document.body}
    />
  );
};

const customStyles = (params) => {
  const { isInvalid, isCorrect, } = params;

  return {
    control: (provided, state) => ({
      ...provided,
      height: 61,
      cursor: 'pointer',
      transition: 'all 0.2s',
      boxShadow: 'none',
      border: `2px solid ${getControlBorderColor(state.isFocused, isInvalid, isCorrect)}`,
      '&:hover': {
        border: `2px solid ${state.isFocused ? '#999999' : '#dbdbdb'}`,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: 57,
      padding: 13,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      color: '#8a8695',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#999999',
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 2,
      marginBottom: 0,
      borderRadius: 5,
      boxShadow: '0 0 0 1px rgba(68, 68, 68, 0.11)',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      minHeight: 40,
      paddingLeft: 18,
      paddingRight: 29,
      fontSize: 14,
      fontWeight: state.isSelected ? 'bold' : 400,
      color: '#8a8695',
      transition: 'all 0.2s',
      cursor: 'pointer',
      backgroundColor: state.isFocused && '#f6f6f6',
      '&:active': {
        backgroundColor: '#f6f6f6',
      },
    }),
  }
};

const getControlBorderColor = (isFocused, isInvalid, isCorrect) => {
  if (isFocused) {
    return '#999999';
  }
    if (isInvalid) {
      return '#ec8282';
    } else if (isCorrect) {
      return '#a9ec82';
    }
      return '#d6d2d8';


};

Select.propTypes = {
  input: PropTypes.object.isRequired,
  isSearchable: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  meta: PropTypes.object.isRequired,
  allowEmptyOption: PropTypes.bool,
  placeholder: PropTypes.string,
};

Select.defaultProps = {
  isSearchable: false,
  id: '',
  placeholder: '',
  allowEmptyOption: true,
};

export default Select;
